import { call, put, takeEvery, takeLatest, select } from 'redux-saga/effects';
import _ from 'lodash';
import invokeApi, { appendLocaleInCMSRequest } from '../network';
import networkConfig from '../network/config';
import { setErrorCode } from '../redux/Actions/ErrorAction';
import { storeClosedErrorCode } from './../constants/Strings';
import { NEARBY_STORES_SUCCESS, NEARBY_STORES_ERROR, NEARBY_STORES, DISTANCE_GOOGLE_API_SUCCESS, DISTANCE_GOOGLE_API_ERROR, DISTANCE_GOOGLE_API, STORE_STATUS, STORE_STATUS_SUCCESS, STORE_STATUS_ERROR, STORE_AVAILABLE_TIME_SLOTS_REQUEST, STORE_AVAILABLE_TIME_SLOTS_SUCCESS, STORE_AVAILABLE_TIME_SLOTS_FAILURE, GET_STORE_STATUS_ON_TIME, GET_STORE_STATUS_ON_TIME_SUCCESS, GET_STORE_STATUS_ON_TIME_ERROR, SET_STORE_FAVOURITE, SET_STORE_UN_FAVOURITE, STORE_AVAILABLE_ALL_TIME_SLOTS_REQUEST, STORE_AVAILABLE_ALL_TIME_SLOTS_SUCCESS, STORE_AVAILABLE_ALL_TIME_SLOTS_FAILURE, ORDER_READY_DATETIME_UPDATE, ORDER_READY_DATETIME_UPDATED_SUCCESS, ORDER_READY_DATETIME_UPDATED_ERROR, GET_STORE_DETAILS, GET_STORE_DETAILS_SUCCESS, GET_STORE_DETAILS_FAILURE, GET_RESTAURANT_DETAILS_FAILURE, GET_RESTAURANT_DETAILS, GET_RESTAURANT_DETAILS_SUCCESS, FAVORITE_STORE_STATUS, FAVORITE_STORE_STATUS_SUCCESS, FAVORITE_STORE_STATUS_ERROR, GET_STORES_DETAILS_CONTENT_FULL, GET_STORES_DETAILS_CONTENT_FULL_SUCCESS, GET_STORES_DETAILS_CONTENT_FULL_FAILURE, SET_STORE_UN_FAVOURITE_ERROR, SET_STORE_UN_FAVOURITE_SUCCESS, SET_STORE_FAVOURITE_SUCCESS, SET_STORE_FAVOURITE_ERROR, GET_CONTACT_US_RESTAURANT_DETAILS, GET_CONTACT_US_RESTAURANT_DETAILS_FAILURE, GET_CONTACT_US_RESTAURANT_DETAILS_SUCCESS, X_AKAMAI_ORIGIN, KFC_RENEGADE_GOOGLE_PLACES, STORE_SCHEDULE_DATA, SELECTED_DISPOSITION, REORDER_UPDATE_DELIVERY, GET_DELIVERY_LOCATION_LOCALIZATION, GET_DELIVERY_LOCATION_LOCALIZATION_FAILURE, GET_DELIVERY_LOCATION_LOCALIZATION_SUCCESS, GET_STORE_ORDER_CAPACITY, GET_STORE_ORDER_CAPACITY_FAILURE, GET_STORE_ORDER_CAPACITY_SUCCESS, } from '../constants';
import Strings from '../constants/Strings';
import { getCustomerInfo } from '../redux/Actions/OrderservAction';
import SharedUtils from '../utils/SharedUtils';
import { modifyStoresData, validStoresWithSummary, getPayload } from '../redux/Reducers/StoresReducer';
import { tenantReducerSelector } from './placesAutocompleteSaga';
export function* NearbyStoresCall(data) {
    const { payload: { geohash, updatedStores }, } = data;
    try {
        const tenantReducer = yield select((state) => state.tenantReducer);
        const { tenantId } = tenantReducer;
        const { response } = yield call(invokeApi, networkConfig.storeStatus.nearbyStoresSearch, {
            queryProps: { tenantId, geohash },
        });
        // All Errors solved from RN part
        if (response) {
            yield put({
                type: NEARBY_STORES_SUCCESS,
                response,
                updatedStores,
            });
        }
        else {
            yield put({
                type: NEARBY_STORES_ERROR,
                updatedStores,
            });
        }
    }
    catch (error) {
        yield put({
            type: NEARBY_STORES_ERROR,
            updatedStores,
        });
    }
}
export default function* NearbyStoresSaga() {
    yield takeEvery(NEARBY_STORES, NearbyStoresCall);
}
export function* DistanceGoogleApiCall(data) {
    try {
        const { payload: { origin, destination, store, googleConfig, distanceMetrics }, } = data;
        const headers = {
            [X_AKAMAI_ORIGIN]: KFC_RENEGADE_GOOGLE_PLACES,
        };
        const distanceMetric = distanceMetrics === Strings.km ? Strings.metric : Strings.imperial;
        const resp = yield call(invokeApi, networkConfig.storeStatus.googleDistance, {
            queryProps: {
                units: distanceMetric,
                origins: origin,
                destinations: destination,
                key: googleConfig?.key,
            },
        }, headers);
        if (resp.status >= 400) {
            yield put(setErrorCode(resp.status));
        }
        const response = store?.length > 0 &&
            resp.response?.origin_addresses?.length > 0 &&
            store.map((data, i) => {
                return {
                    ...data,
                    address: _.get(resp.response, ['origin_addresses', i]),
                    distance: _.get(resp.response, ['rows', i, 'elements', '0']),
                };
            });
        if (response) {
            yield put({
                type: DISTANCE_GOOGLE_API_SUCCESS,
                response,
            });
        }
        else {
            yield put({
                type: DISTANCE_GOOGLE_API_ERROR,
            });
        }
    }
    catch (error) {
        yield put({
            type: DISTANCE_GOOGLE_API_ERROR,
        });
    }
}
export function* DistanceGoogleApiSaga() {
    yield takeEvery(DISTANCE_GOOGLE_API, DistanceGoogleApiCall);
}
export const cartReducerStateValue = (state) => state.cartReducer;
export const storeReducerStateValue = (state) => state.storesReducer;
export const isFavoriteStoreSuccess = (isFavoriteStore) => {
    return isFavoriteStore ? FAVORITE_STORE_STATUS_SUCCESS : STORE_STATUS_SUCCESS;
};
export const isFavoriteStoreFailure = (isFavoriteStore) => {
    return isFavoriteStore ? FAVORITE_STORE_STATUS_ERROR : STORE_STATUS_ERROR;
};
export function* StoreStatusApiCall(request) {
    try {
        const { payload: { data, store, tenantId, isFavoritePage, isFavoriteStore }, sucessCallback = null, } = request;
        // Need to be moved to common place
        const headers = {
            'x-tenant-id': tenantId,
        };
        const resp = yield call(invokeApi, _.get(networkConfig, Strings.bulkStore), null, headers, data);
        if (resp.status >= 400) {
            yield put(setErrorCode(resp.status));
        }
        const storesList = (store?.length > 0 &&
            resp.response?.length > 0 &&
            store.map((data) => {
                const statusObj = filterMatchingStoreIds(resp, data);
                return { ...data, summary: _.get(statusObj, [0, 'summary']), service: _.get(statusObj, [0, 'service']) };
            })) ||
            resp.response;
        const response = isFavoritePage
            ? _.uniqBy(storesList, (elm) => JSON.stringify([elm.storeId, elm.service]))
            : _.uniqBy(storesList, (elm) => JSON.stringify([elm.id, elm.service]));
        if (response) {
            const cartReducer = yield select(cartReducerStateValue);
            const storeReducer = yield select(storeReducerStateValue);
            const tenantReducer = yield select(tenantReducerSelector);
            const storeID = storeReducer?.store?.storeId ?? storeReducer?.store?.id;
            const responseStoreID = response[0]?.storeId ?? response[0]?.id;
            const updateStoreDataFromBasket = tenantReducer?.updateStoreDataFromBasket ?? false;
            if (response?.length === 1 &&
                storeID &&
                responseStoreID &&
                updateStoreDataFromBasket &&
                (storeID !== responseStoreID || storeReducer?.store?.service !== response[0]?.service) &&
                storeID !== cartReducer?.cartData?.store?.storeId) {
                const storePayload = getPayload(cartReducer?.cartData, response);
                yield put({
                    type: STORE_SCHEDULE_DATA,
                    payload: storePayload,
                });
                yield put({
                    type: SELECTED_DISPOSITION,
                    payload: { selectedDisposition: response[0]?.service },
                });
                yield put({
                    type: REORDER_UPDATE_DELIVERY,
                    payload: { deliveryAddress: storePayload[1]?.store?.addresses[0]?.address ?? {} },
                });
            }
            yield put({
                type: isFavoriteStoreSuccess(isFavoriteStore),
                response,
            });
            sucessCallback?.(validStoresWithSummary(response));
        }
        else {
            yield put({
                type: isFavoriteStoreFailure(isFavoriteStore),
            });
        }
    }
    catch (error) {
        const { payload: { isFavoriteStore }, } = request;
        yield put({
            type: isFavoriteStoreFailure(isFavoriteStore),
        });
    }
}
export const filterMatchingStoreIds = (response, data) => {
    return response.response?.filter((status) => status.storeId === data.id && (!data.service || (data.service && data.service === status.service)));
};
export function* StoreStatusApiSaga() {
    yield takeLatest(STORE_STATUS, StoreStatusApiCall);
}
export function* favoriteStoreStatusApiSaga() {
    yield takeLatest(FAVORITE_STORE_STATUS, StoreStatusApiCall);
}
export function* availableTimeSlotsApiCall(request) {
    try {
        const { payload: { data, tenantId }, } = request;
        // Need to be moved to common place
        const headers = {
            'x-tenant-id': tenantId,
        };
        const { response, status } = yield call(invokeApi, _.get(networkConfig, Strings.storeAvailableTimeSlots), { queryProps: data }, headers);
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response) {
            yield put({
                type: STORE_AVAILABLE_TIME_SLOTS_SUCCESS,
                response,
            });
            request.sucessCallBack && request.sucessCallBack(response);
        }
        else {
            yield put({
                type: STORE_AVAILABLE_TIME_SLOTS_FAILURE,
            });
        }
        request.errorCallback && request.errorCallback();
    }
    catch (error) {
        yield put({
            type: STORE_AVAILABLE_TIME_SLOTS_FAILURE,
        });
    }
    request.errorCallback && request.errorCallback();
}
export function* availableTimeSlotsApiSaga() {
    yield takeLatest(STORE_AVAILABLE_TIME_SLOTS_REQUEST, availableTimeSlotsApiCall);
}
export function* storeAvailableAllTimeSlotsApiCall(request) {
    try {
        const { payload: { data, tenantId }, } = request;
        // Need to be moved to common place
        const headers = {
            'x-tenant-id': tenantId,
        };
        const { response, status } = yield call(invokeApi, _.get(networkConfig, Strings.storeAvailableAllTimeSlots), { queryProps: data }, headers);
        if (status > 400) {
            yield put(setErrorCode(status));
        }
        if (response) {
            yield put({
                type: STORE_AVAILABLE_ALL_TIME_SLOTS_SUCCESS,
                response,
            });
            request.sucessCallBack && request.sucessCallBack(response);
        }
        else {
            yield put({
                type: STORE_AVAILABLE_ALL_TIME_SLOTS_FAILURE,
            });
        }
        request.errorCallback && request.errorCallback(response);
    }
    catch (error) {
        yield put({
            type: STORE_AVAILABLE_ALL_TIME_SLOTS_FAILURE,
        });
        request.errorCallback && request.errorCallback(error);
    }
}
export function* storeAvailableAllTimeSlotsApiSaga() {
    yield takeLatest(STORE_AVAILABLE_ALL_TIME_SLOTS_REQUEST, storeAvailableAllTimeSlotsApiCall);
}
export function* getStoreStatusForTimeCall(request) {
    try {
        const { payload: { data, tenantId }, successCallback, errorCallback, } = request;
        // Need to be moved to common place
        const headers = {
            'x-tenant-id': tenantId,
        };
        let tempData = {
            queryProps: data,
        };
        const { response, status } = yield call(invokeApi, networkConfig.storeStatus.storeStatusForTime, tempData, headers);
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response) {
            const responsePayload = [
                {
                    storeId: data?.storeid,
                    service: data?.service,
                    channel: data?.channel,
                    summary: response,
                },
            ];
            yield put({
                type: GET_STORE_STATUS_ON_TIME_SUCCESS,
                payload: data,
                response: responsePayload,
            });
            successCallback && successCallback(responsePayload);
        }
        else {
            yield put({
                type: GET_STORE_STATUS_ON_TIME_ERROR,
            });
            errorCallback && errorCallback();
        }
    }
    catch (error) {
        const { errorCallback } = request;
        yield put({
            type: GET_STORE_STATUS_ON_TIME_ERROR,
        });
        errorCallback && errorCallback();
    }
}
export function* getOrderReadyDateTimeUpdateCall(request) {
    try {
        const { payload: { postBody, tenantId }, } = request;
        const params = { queryProps: request?.payload?.params };
        // Need to be moved to common place
        const headers = {
            'x-tenant-id': tenantId,
        };
        const { response, status } = yield call(invokeApi, networkConfig.storeStatus.readyDateTimeUpdate, params, headers, postBody);
        if (status >= 400 && !storeClosedErrorCode.includes(response?.errorCode)) {
            yield put(setErrorCode(status));
        }
        if (response && response?.id) {
            yield put({
                type: ORDER_READY_DATETIME_UPDATED_SUCCESS,
                response,
            });
            request.successCallBack && request.successCallBack();
        }
        else {
            yield put({
                type: ORDER_READY_DATETIME_UPDATED_ERROR,
            });
            request.errorCallBack && request.errorCallBack();
        }
    }
    catch (error) {
        yield put({
            type: ORDER_READY_DATETIME_UPDATED_ERROR,
        });
        request.errorCallBack && request.errorCallBack();
    }
}
export function* getStoreStatusForTimeSaga() {
    yield takeLatest(GET_STORE_STATUS_ON_TIME, getStoreStatusForTimeCall);
}
export function* getOrderReadyDateTimeUpdate() {
    yield takeLatest(ORDER_READY_DATETIME_UPDATE, getOrderReadyDateTimeUpdateCall);
}
export function* setStoreFavouriteCall(request) {
    try {
        const { successCallBack, errorCallBack } = request;
        const { status } = yield call(invokeApi, networkConfig.addStoreToFav, {
            queryProps: { customerId: request?.payload?.customerId },
        }, {
            'x-tenant-id': request?.payload?.tenantId,
            'x-is-registered-user': 'true',
            'x-user-id': request?.payload?.customerId,
            'Content-Type': 'application/json',
        }, request?.payload?.data);
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (status === 200) {
            yield put({
                type: SET_STORE_FAVOURITE_SUCCESS,
            });
            const phoneNumber = SharedUtils.getPhoneNumberFromToken();
            const customerPayload = {
                customerId: request?.payload?.customerId,
                tenantId: request?.payload?.tenantId,
                phoneNumber,
                updateUserData: true,
            };
            yield put(getCustomerInfo(customerPayload));
            successCallBack && successCallBack();
        }
        else {
            yield put({
                type: SET_STORE_FAVOURITE_ERROR,
            });
            errorCallBack && errorCallBack();
        }
    }
    catch (e) {
        const { errorCallBack } = request;
        yield put({
            type: SET_STORE_FAVOURITE_ERROR,
        });
        errorCallBack && errorCallBack();
    }
}
export function* setStoresFavouriteSaga() {
    yield takeLatest(SET_STORE_FAVOURITE, setStoreFavouriteCall);
}
export function* setStoreUnFavouriteCall(request) {
    try {
        const { successCallBack, errorCallBack } = request;
        const { status } = yield call(invokeApi, networkConfig.removeStoreToFav, {
            queryProps: {
                customerId: request?.payload?.customerId,
                storeId: request?.payload?.storeId,
            },
        }, {
            'x-tenant-id': request?.payload?.tenantId,
            'x-is-registered-user': 'true',
            'x-user-id': request?.payload?.customerId,
        });
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (status === 200) {
            yield put({
                type: SET_STORE_UN_FAVOURITE_SUCCESS,
            });
            const phoneNumber = SharedUtils.getPhoneNumberFromToken();
            const customerPayload = {
                customerId: request?.payload?.customerId,
                tenantId: request?.payload?.tenantId,
                phoneNumber,
                updateUserData: true,
            };
            yield put(getCustomerInfo(customerPayload));
            successCallBack && successCallBack();
        }
        else {
            yield put({
                type: SET_STORE_UN_FAVOURITE_ERROR,
            });
            errorCallBack && errorCallBack();
        }
    }
    catch (e) {
        const { errorCallBack } = request;
        yield put({
            type: SET_STORE_UN_FAVOURITE_ERROR,
        });
        errorCallBack && errorCallBack();
    }
}
export function* setStoresUnFavouriteSaga() {
    yield takeLatest(SET_STORE_UN_FAVOURITE, setStoreUnFavouriteCall);
}
export function* getStoreDetails(request) {
    try {
        const { sucessCallback, errorCallback } = request;
        const { response } = yield call(invokeApi, networkConfig.storeStatus.storeDetails, {
            queryProps: { storeId: request?.payload?.storeId },
        }, {
            'x-tenant-id': request?.payload?.tenantId,
            'Content-Type': 'application/json',
        });
        if (response?.basicDetails?.id) {
            const payload = _.isEmpty(response) ? response : modifyStoresData(response);
            yield put({
                type: GET_STORE_DETAILS_SUCCESS,
                payload,
            });
            sucessCallback && sucessCallback(payload);
        }
        else {
            yield put({
                type: GET_STORE_DETAILS_FAILURE,
            });
            errorCallback && errorCallback();
        }
    }
    catch (e) {
        const { errorCallback } = request;
        yield put({
            type: GET_STORE_DETAILS_FAILURE,
        });
        errorCallback && errorCallback();
    }
}
export function* getStoreDetailsSaga() {
    yield takeLatest(GET_STORE_DETAILS, getStoreDetails);
}
export function* getRestaurantDetails(request) {
    try {
        const { sucessCallback, errorCallback } = request;
        const { response } = yield call(invokeApi, networkConfig.storeStatus.restaurantDetails, {
            queryProps: { storeName: request?.payload?.storeName, postCode: request?.payload?.postCode },
        }, {
            'x-tenant-id': request?.payload?.tenantId,
            'Content-Type': 'application/json',
        });
        if (response?.basicDetails?.id) {
            const payload = _.isEmpty(response) ? response : modifyStoresData(response);
            yield put({
                type: GET_RESTAURANT_DETAILS_SUCCESS,
                payload,
            });
            sucessCallback && sucessCallback(payload);
        }
        else {
            yield put({
                type: GET_RESTAURANT_DETAILS_FAILURE,
            });
            errorCallback && errorCallback();
        }
    }
    catch (e) {
        const { errorCallback } = request;
        yield put({
            type: GET_RESTAURANT_DETAILS_FAILURE,
        });
        errorCallback && errorCallback();
    }
}
export function* getRestaurantDetailsSaga() {
    yield takeLatest(GET_RESTAURANT_DETAILS, getRestaurantDetails);
}
export function* getStoreDetailsContentFull(data) {
    let result = {};
    const { payload } = data;
    const response = yield call(payload.object.getEntries, appendLocaleInCMSRequest(payload.contentFull));
    if (response && response !== undefined && response !== null) {
        //if logged in and localized (Store selected)
        const { items = [] } = response;
        result = { ...result, details: items[0] };
        yield put({
            type: GET_STORES_DETAILS_CONTENT_FULL_SUCCESS,
            response: result,
        });
    }
    else {
        yield put({
            type: GET_STORES_DETAILS_CONTENT_FULL_FAILURE,
        });
    }
}
export function* getStoreDetailsContentFullData() {
    yield takeLatest(GET_STORES_DETAILS_CONTENT_FULL, getStoreDetailsContentFull);
}
export function* getContactUsRestaurantDetails(request) {
    try {
        const { sucessCallback, errorCallback } = request;
        const { response } = yield call(invokeApi, networkConfig.storeStatus.contactUsRestaurantDetails, {
            queryProps: {},
        }, {
            'x-tenant-id': request?.payload?.tenantId,
            'Content-Type': 'application/json',
        });
        if (response && response !== undefined && response !== null) {
            const payload = response;
            yield put({
                type: GET_CONTACT_US_RESTAURANT_DETAILS_SUCCESS,
                payload,
            });
            sucessCallback && sucessCallback(payload);
        }
        else {
            yield put({
                type: GET_CONTACT_US_RESTAURANT_DETAILS_FAILURE,
            });
            errorCallback && errorCallback();
        }
    }
    catch (e) {
        const { errorCallback } = request;
        yield put({
            type: GET_CONTACT_US_RESTAURANT_DETAILS_FAILURE,
        });
        errorCallback && errorCallback();
    }
}
export function* getContactUsRestaurantDetailsSaga() {
    yield takeLatest(GET_CONTACT_US_RESTAURANT_DETAILS, getContactUsRestaurantDetails);
}
export function* getDeliveryLocationLocalization(data) {
    try {
        const { payload } = data;
        const searchType = payload['contentFull']?.['fields.slug'] || '';
        const response = yield call(payload.object.getEntries, appendLocaleInCMSRequest(payload.contentFull));
        if (response) {
            const { items = {} } = response;
            const deliveryLocalizationData = {};
            if (searchType === 'postcodes') {
                deliveryLocalizationData.postalCodes = items?.[0]?.fields?.data;
            }
            else {
                deliveryLocalizationData.prefectures = items?.[0]?.fields?.data;
            }
            yield put({
                type: GET_DELIVERY_LOCATION_LOCALIZATION_SUCCESS,
                searchType: searchType,
                response: deliveryLocalizationData,
            });
        }
        else {
            yield put({
                type: GET_DELIVERY_LOCATION_LOCALIZATION_FAILURE,
            });
        }
    }
    catch (e) {
        yield put({
            type: GET_DELIVERY_LOCATION_LOCALIZATION_FAILURE,
        });
    }
}
export function* getDeliveryLocationLocalizationData() {
    yield takeLatest(GET_DELIVERY_LOCATION_LOCALIZATION, getDeliveryLocationLocalization);
}
export function* getStoreOrderCapacity(data) {
    const { payload: { storeId, dateTimeEpoch }, } = data;
    try {
        const { response } = yield call(invokeApi, networkConfig.storeStatus.orderCapacity, {
            queryProps: { storeId, dateTimeEpoch },
        });
        if (response) {
            yield put({
                type: GET_STORE_ORDER_CAPACITY_SUCCESS,
                response,
            });
        }
        else {
            yield put({
                type: GET_STORE_ORDER_CAPACITY_FAILURE,
            });
        }
    }
    catch (e) {
        yield put({
            type: GET_STORE_ORDER_CAPACITY_FAILURE,
        });
    }
}
export function* getStoreOrderCapacityData() {
    yield takeLatest(GET_STORE_ORDER_CAPACITY, getStoreOrderCapacity);
}
